import { Editor } from '@tiptap/core'
import { Fragment, memo } from 'react'
import MenuButton from './MenuButton'
import menu, { MenuItemProps } from '../config/menu'
import MenuSelect from './MenuSelect'
import MenuItemDivider from './MenuItemDivider'

const MenuExpanded = ({editor} : { editor: Editor, menuItems:  MenuItemProps[] } ) => {
 
    return <div className="menu">{ menu.map((b,i) => {
            if(b.hide) return <Fragment key={`hidden-${i}`}></Fragment>
            switch(b.type) {
                case 'space':
                    return <MenuItemDivider key={`space-${i}`} />
                case 'button':
                case 'radioButton':
                    return <MenuButton key={b.id} editor={editor} {...b} />
                case 'select':
                    return <MenuSelect key={b.id} editor={editor} {...b} />
            }
            return <></>
        }) }</div>
        
}

const MemoizedMenu = memo(MenuExpanded)

const Menu = ({editor} : {editor : Editor}) => {
    return <MemoizedMenu editor={editor} menuItems={menu} />
}

export default Menu;
